import { useState } from "react";
import { useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { hasValidProfile } from "../../../apis/private.api";
import { useUser } from "../../../hooks/User";
import { textChooser } from "../../../util/textChooser";
import { InfoText } from "../../info_text";
import { Button } from "./button";
import "./buttonApplyJob.scss";
import { IUserPostulation } from "../../../constants/app.dto";

interface ButtonApplyJobProps extends IUserPostulation{}

export const ButtonApplyJob = ({hasSubscription}: ButtonApplyJobProps) => {
  
  const [ isValidProfile, setValidProfile ] = useState(false);
  const email = useUser().getDataByAttributeName("email");

  const { pathname } = useLocation();
  const { cid, oid } = useParams();

  useEffect(() => {
    if(email){
      hasValidProfile(email).then(({verify}: any) => {
        setValidProfile(verify);
      })
    }
  },[]);

  return (
    <div className="button-apply-job-wrapper">
      <Button disabled={hasSubscription} primary>
        {!hasSubscription ? (
          <Link to={email ? `/apply/${oid}/${cid}`:`/login?ref=${pathname}`}>
            {textChooser("txt156")}
          </Link>
        ) : (
          <span>
            {textChooser("txt156")}
          </span>
        )}
      </Button>

      <InfoText 
        hidden={isValidProfile}
        text={textChooser("txt183")} 
        type="danger" 
      />
    </div>
  )
}